import { v4 as uuidv4 } from 'uuid';

// RequestTracker.js
// Tracks request meta: id, start/end time, status
export default class RequestTracker {
  constructor({ url, method, data, params }) {
    this.id = uuidv4();
    this.url = url;
    this.method = method;
    this.data = data;
    this.params = params;
    this.attempts = [{
      startTime: Date.now(),
      endTime: null,
      status: 'pending',
    }];
  }
  markComplete(status) {
    const last = this.attempts[this.attempts.length - 1];
    last.status = status;
    last.endTime = Date.now();
  }
  addRetry() {
    this.attempts.push({
      startTime: Date.now(),
      endTime: null,
      status: 'retry',
    });
  }
  getMeta() {
    return {
      id: this.id,
      url: this.url,
      method: this.method,
      attempts: this.attempts,
    };
  }
}
